<template>
  <section>
    <div class="fieldWrap tableWrap">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt></dt>
            <dd>
              ※ {}로 감싸진 문구는 DB에서 자동으로 불러와지는 값으로 절대 수정하시면 안됩니다.<br/>
              예를 들어, {NAME} 은 DB에서 불러온 회원의 이름으로 '자동치환' 되어 발송됩니다. <br/>
              Ex) {NAME} → 홍길동
            </dd>
          </dl>
        </li>
      </ul>
    </div>
    <template v-if="templateList.length > 0">
      <div class="d-flex flex-wrap">
        <div class="smsTemplateBx" v-for="(item) in templateList" :key="item.smsTemplateId">
          <ul>
            <li class="smsTemplateList">
              <h4 class="templateTit mb-4">{{ item.title }}</h4>
              <div class="templateAreaBx">
                <p class="mgb">
                  <v-col class="textAreaH">
                    <v-textarea
                        name="input-7-1"
                        :label="item.contents"
                        v-model="item.contents"
                        value=""
                        hint="Hint text"
                        solo
                        flat
                        outlined
                    />
                  </v-col>
                </p>
                <template v-if="!item.isModified">
                  <v-col class="d-flex justify-space-between align-center checkSt">
                    <v-checkbox label="사용" v-model="item.activated" @change="changeActivatedTemplate(item.smsTemplateId)"/>
                    <v-btn color="#1991eb" dark class="vIconResize" @click="editTemplate(item, true)">
                      <v-icon>mdi mdi-pencil</v-icon>
                      수정
                    </v-btn>
                  </v-col>
                </template>
                <template v-if="item.isModified">
                  <v-col class="d-flex justify-space-between align-center checkSt">
                    <v-btn color="#1991eb" dark class="vIconResize" @click="updateTemplate(item)">
                      <v-icon>mdi mdi-pencil</v-icon>
                      확인
                    </v-btn>
                    <v-btn color="#1991eb" dark class="vIconResize" @click="editTemplate(item, false)">
                      <v-icon>mdi mdi-pencil</v-icon>
                      취소
                    </v-btn>
                  </v-col>
                </template>
              </div>
            </li>

          </ul>
        </div>
      </div>

    </template>
    <template v-if="templateList.length > 0">
      <div class="text-center">
        <v-container>
          <v-row justify="center">
            <v-col cols="8">
              <v-container class="max-width">
                <v-pagination
                    v-model="templatePageOptions.page"
                    class="my-4"
                    :length="templatePageOptions.length"
                    :total-visible="templatePageOptions.visible"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                ></v-pagination>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
    <template v-if="templateList.length == 0">
      <p class="d-flex justify-center tableWrap mt-5">
        등록 된 템플릿이 없습니다.
      </p>
    </template>
  </section>
</template>

<script>
import smsApi from '@/api/SmsApi';
import _ from 'lodash';

export default {
  name: "SmsSetting",
  data: () => ({
    isModified: false,
    templateList: [],
    templatePageOptions: {
      page: 1,
      itemsPerPage: 4,
      length: 0,
      visible: 10
    },
    templateTotalItems: 0
  }),
  watch: {
    templatePageOptions: {
      handler() {
        this.getTemplateList();
      },
      deep: true
    }
  },
  methods: {
    async getTemplateList() {
      const {page, itemsPerPage} = this.templatePageOptions;
      let params = {
        page: (page - 1),
        size: itemsPerPage,
        system: true
      }

      let data = await smsApi.getTemplateList(params);

      // console.log(data);
      this.templateList = data.content;

      this.templateTotalItems = data.totalElements;
      this.templatePageOptions.length = data.totalPages;
    },
    templateUpdate(item) {
      var param = {
        smsTemplateId: item.smsTemplateId,
        title: item.title,
        contents: item.contents
      }
      smsApi.updateTemplate(param).then(data => {
        alert("수정되었습니다.");
        if (data) this.editTemplate(item, false);
      });
    },
    changeActivatedTemplate(id) {
      if (!confirm("사용여부를 변경하시겠습니까?")) {
        return false;
      }

      smsApi.changeActivatedTemplate(id).then(data => {
        alert("변경되었습니다.");
        if (data) this.getTemplateList();
      });
    },
    editTemplate(item, template) {
      item.isModified = template;
      this.templateList = _.cloneDeep(this.templateList);
    },
    updateTemplate(item) {
      var param = {
        smsTemplateId: item.smsTemplateId,
        title: item.title,
        contents: item.contents
      }
      smsApi.updateTemplate(param).then(data => {
        alert("수정되었습니다.");
        if (data) this.editTemplate(item, false);
      });
    }
  },
  created: function () {
    this.getTemplateList();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.fieldWrap {
  @include form-bx;
  display: flex;
  align-items: center;

  .fieldBx {
    position: relative;
    width: 1600px;

    .formList {
      display: flex;
      flex-direction: row;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

        }
      }
    }
  }
}

.smsTemplateBx {
  width: 23%;
  margin-right: 2.6%;
  border: 1px solid #dcdee3;
  background: #f8f8f8;
  margin-bottom: 25px;

  &:nth-of-type(4n) {
    margin-right: 0;
  }

  ul {
    padding: 15px;
  }

  .templateTit {
    display: flex;
    align-items: center;
    margin-bottom: 1px;
    padding-bottom: 5px;
    border-bottom: 1px solid #dcdee3;
  }

  .col {
    padding: 0;
  }
}
</style>
